export default import.meta.ROLLDOWN_FILE_URL_XE2TbjLccIt5As8HIB9R5A